import { render } from "./InfoMain.vue?vue&type=template&id=0076ba38"
import script from "./InfoMain.vue?vue&type=script&lang=js"
export * from "./InfoMain.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__